/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import {
  GET_TENANT_PROVIDER_LIST,
  BERLIN_TENANT_ID_HEADER,
  BERLIN_API_V1_VERSION
} from '../../constants/ServiceConstants';

import utils from '../../../../common/utils';

export default class TenantProviderServiceV2 extends BaseService {
  constructor() {
    super(GET_TENANT_PROVIDER_LIST, 'tenantProviderListStatus');
  }

  handleEvent(eventName, eventParams) {
    const { tenantId, sysTosysToken } = eventParams;
    const options = {
      headers: {
        Authorization: `Bearer ${sysTosysToken}`,
        'Content-Type': 'application/json',
        [BERLIN_TENANT_ID_HEADER]: tenantId
      }
    };
    return this.getClient('berlin').get(`/${BERLIN_API_V1_VERSION}/tenant/${tenantId}/providers`, options);
  }

  handleResponse(response) {
    // eslint-disable-line class-methods-use-this
    Framework.getStoreRegistry().getStore('tenantState').setTenantProviderList(response?.data);
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
    }
    const notification = {
      open: true,
      message: 'Error fetching provider list',
      type: 'error'
    };
    Framework.getStoreRegistry().getStore('notificationState').set(notification);
  }
}
